import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SamService } from 'src/app/services/sam/sam.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fiche-sam',
  templateUrl: './fiche-sam.fragment.html',
  styleUrls: [
    './fiche-sam.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class FicheSamFragment implements OnInit {

  public fichesSam: any[] = [];
  public patientId: string;
  currentIndex: number = 0;

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private _sam: SamService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.updateCurrentFicheReadStatusIfNeeded();
  }

  private async updateCurrentFicheReadStatusIfNeeded(): Promise<void> {
    const fiche = this.fichesSam?.[this.currentIndex];
    if (!fiche) return;

    // Ne recharge que si pas encore renseigné
    if (fiche.isRead === undefined || fiche.isRead === null) {
      const r = await this._sam.isRead(fiche.codeSam, this.patientId);
      fiche.isRead = !!r?.isSamRead;
    }
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeConfirmationModal();
  }

  public closeConfirmationModal(): void {
    this.closeEmitter.emit();
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }

  async previous() {
    if (this.currentIndex === 0) {
      this.currentIndex = this.fichesSam.length -1;
    } else {
      this.currentIndex--;
    }
    await this.updateCurrentFicheReadStatusIfNeeded();
  }

  async next() {
    if (this.currentIndex === this.fichesSam.length -1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
    await this.updateCurrentFicheReadStatusIfNeeded();
  }

  // public _addReadenFiche() {
  //   this._sam.addRead(this.fichesSam[this.currentIndex].codeSam, this.patientId);
  // }
  public onReadStatusChange(isChecked: boolean): void {
    this._addReadenFiche(isChecked);
  }

  private _addReadenFiche(isRead: boolean) {
    const codeSam = this.fichesSam[this.currentIndex].codeSam;

    if (isRead) {
      this._sam.addRead(codeSam, this.patientId);
    } else {
      this._sam.notRead(codeSam, this.patientId);
    }
  }
}
